import alert from './index.vue';
import Vue from 'vue';
const Alert = Vue.extend(alert);

let instance = null;

function $Alert(options) {
    if (!instance) {
        instance = new Alert({propsData: {params: options}}).$mount();
        document.body.appendChild(instance.$el);
    }
    if (options) {
        instance._zIndex = options.zIndex || instance._zIndex;
    }
    return $Alert;
}

$Alert.show = function () {
    $Alert();
    instance.show();
};

$Alert.hide = function () {
    $Alert();
    instance.hide();
};


export default $Alert;